module.exports = __webpack_public_path__ + "6cf0d88d3577c78ae649fc667fdaf6a5.png";